import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { MdmConfigurationRes } from './type';
export const getIntegratableApp = async (appId: string) => {
  const res = await apiClient.GET('/v2/apps/{id}', {
    params: {
      path: {
        id: appId
      }
    }
  });
  return getDataOrThrowApiError(res);
};
export const getPresignedUrl = async (filename: string) => {
  const res = await apiClient.GET('/v2/s3/presigned-url/image', {
    params: {
      query: {
        filename
      }
    }
  });
  return getDataOrThrowApiError(res);
};

// TODO: MDMエンドポイントがバックエンドで実装されたら有効化
export const getMdmConfiguration = (_appIntegrationId: string): Promise<MdmConfigurationRes> => {
  // const res = await apiClient.GET(
  //   "/v2/app-integrations/{id}/settings/mdm-configuration",
  //   {
  //     params: { path: { id: appIntegrationId } },
  //   },
  // );
  // return getDataOrThrowApiError(res);

  // 一時的なモック実装
  return Promise.resolve({
    tenantId: undefined,
    clientId: undefined,
    hasClientSecret: false,
    lastUpdated: undefined
  });
};

// Software data from app-integration
export const getSoftwareFromAppIntegration = async (appIntegrationId: string) => {
  const res = await apiClient.GET('/v2/software/app-integrations/{appIntegrationId}', {
    params: {
      path: {
        appIntegrationId
      }
    }
  });
  return getDataOrThrowApiError(res);
};